const useGetAllPermissionOfUser = (profileUser) => profileUser?.roles?.data
  .map((item) => item.permissions.data)
  .flat()
  .map((item) => item.name);

export default useGetAllPermissionOfUser;
